import type { ReactNode } from 'react'

import { Footer } from '../footer'
import { Sidebar } from '../sidebar'
import { WorkspaceStatusBanner } from '../workspace-status-banner'
import { HorizontalLayoutHeader } from './horizontal-layout-header'

export function HorizontalLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <Sidebar />
      <div className="w-full">
        <HorizontalLayoutHeader />
        {/* Renders nothing when the workspace is active. When paused
            or pending_deletion it sits between the header and main
            content so it's the first thing the user sees. */}
        <WorkspaceStatusBanner />
        <main className="min-h-[calc(100svh-9.85rem)] bg-muted/40">{children}</main>
        <Footer />
      </div>
    </>
  )
}
